// src/security/tokenStorage.ts
// Speichert token/user/tstoken und entfernt sie aus der URL.

const STORAGE_MODE: "session" | "local" = "local"; // <-- HIER auf "local" stellen

const KEYS = {
    jwt: "userToken",       // dein JWT
    user: "userParam",      // optionaler user aus der URL
    tsLegacy: "tsToken",    // dein "tstoken" (legacy/external)
};

function store(): Storage {
    return STORAGE_MODE === "session" ? window.sessionStorage : window.localStorage;
}

export function migrateSessionToLocalOnce() {
    try {
        const pairs: Array<[string, string]> = [
            ["userToken", "userToken"],
            ["tsToken",   "tsToken"],
            ["userParam", "userParam"],
        ];

        for (const [keySess, keyLocal] of pairs) {
            const localHas = window.localStorage.getItem(keyLocal);
            const sessVal  = window.sessionStorage.getItem(keySess);
            if (!localHas && sessVal) {
                window.localStorage.setItem(keyLocal, sessVal);
            }
            // Aufräumen (optional, aber empfehlenswert):
            if (sessVal) window.sessionStorage.removeItem(keySess);
        }
    } catch {}
}


export function setToken(token: string)   { store().setItem(KEYS.jwt, token); }
export function getToken(): string | null { return store().getItem(KEYS.jwt); }

export function getLegacyTsToken(): string | null {
    return store().getItem(KEYS.tsLegacy);
}

export function clearAllAuthParams(): void {
    try { window.sessionStorage.removeItem(KEYS.jwt); } catch {}
    try { window.sessionStorage.removeItem(KEYS.user); } catch {}
    try { window.sessionStorage.removeItem(KEYS.tsLegacy); } catch {}
    try { window.localStorage.removeItem(KEYS.jwt); } catch {}
    try { window.localStorage.removeItem(KEYS.user); } catch {}
    try { window.localStorage.removeItem(KEYS.tsLegacy); } catch {}
}

/**
 * Liest token/user/tstoken aus der URL, speichert sie und entfernt sie anschließend.
 * @returns true, wenn mindestens ein Parameter gefunden & entfernt wurde.
 */
export function bootstrapAuthFromURL(): boolean {
    const params = new URLSearchParams(window.location.search);
    let changed = false;

    const jwt = params.get("token");
    if (jwt) {
        store().setItem(KEYS.jwt, jwt);
        params.delete("token");
        changed = true;
    }

    const user = params.get("user");
    if (user) {
        store().setItem(KEYS.user, user);
        params.delete("user");
        changed = true;
    }

    const tsLegacy = params.get("tstoken");
    if (tsLegacy) {
        store().setItem(KEYS.tsLegacy, tsLegacy);
        params.delete("tstoken");
        changed = true;
    }

    if (changed) {
        const base = window.location.origin + window.location.pathname;
        const qs = params.toString();
        const newUrl = qs ? `${base}?${qs}` : base;
        window.history.replaceState({}, document.title, newUrl);
    }
    return changed;
}
